var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { keyframes } from "@emotion/react";
import { ArrowDropDown } from "@mui/icons-material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Button, Grid, IconButton, Menu, MenuItem, Typography, } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { observer } from "mobx-react";
import React, { useState } from "react";
const Grid_breadcrumbEntry = styled(Grid)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    "&:nth-of-type(2):nth-last-of-type(1)": {
        maxWidth: "calc(100% - 7rem)",
    },
    "&:nth-of-type(2):nth-last-of-type(2)": {
        maxWidth: "calc(calc(100% - 7rem) * 0.36)",
    },
    "&:nth-of-type(2):nth-last-of-type(2) ~ .breadcrumbpart": {
        maxWidth: "calc(calc(100% - 7rem) * 0.36)",
    },
    "&:nth-of-type(2):nth-last-of-type(3)": {
        maxWidth: "calc(calc(100% - 7rem) * 0.32)",
    },
    "&:nth-of-type(2):nth-last-of-type(3) ~ .breadcrumbpart": {
        maxWidth: "calc(calc(100% - 7rem) * 0.32)",
    },
    "&:nth-of-type(2)": {
        "& svg": {
            backgroundColor: "white",
            zIndex: "1",
            animation: `${keyframes_invisible} 2s 0s, ${keyframes_rotate_arrow} 0.5s 2s`,
        },
    },
}));
const IconButton_separator = styled(IconButton)(({ theme, buttoncolor }) => ({
    paddingLeft: "2px",
    borderRadius: "4px",
    paddingRight: "2px",
    "&.Mui-disabled": {
        color: buttoncolor,
    },
    "& svg": {
        fontSize: "2rem",
    },
}));
const ArrowDropDown_chevron = styled(ArrowDropDown)(({ theme, color }) => ({
    paddingLeft: "2px",
    borderRadius: "4px",
    paddingRight: "2px",
    color: color,
    fontSize: "2rem",
    verticalAlign: "middle",
}));
const Grid_labelWrapper = styled(Grid)(({ theme }) => ({
    alignItems: "center",
    display: "inline-flex",
}));
const Typography_entryLabel = styled(Typography)(({ theme, font, color }) => ({
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    color: color,
    fontSize: "1.8rem", //var(--default-text-font-size)",
    fontFamily: font,
    lineHeight: 1.75,
    maxWidth: "100%",
    height: "44px",
    padding: "8px 0",
}));
const Typography_entryLabel_clickableLabelWrapper = styled(Typography_entryLabel)(({ theme, font, color }) => ({
    cursor: "pointer",
    height: "44px",
    padding: "8px 0",
    "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.04) !important",
        borderRadius: "4px",
    },
}));
const Div_clickableLabelWrapper = styled("div")(({ theme }) => ({
    cursor: "pointer",
    height: "44px",
    padding: "8px 0",
    "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.04) !important",
        borderRadius: "4px",
    },
}));
const Menu_menu = styled(Menu)(({ theme }) => ({
    "& ul li::before": {
        display: "none",
    },
}));
const Typography_menuItem = styled(Typography)(({ theme, font }) => ({
    color: "#001a37", //"var(--clr-primary)",
    fontSize: "1.6rem", //"var(--default-text-font-size)",
    fontFamily: font,
    lineHeight: 1.5,
}));
const Tooltip_tooltip = styled((_a) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (React.createElement(Tooltip, Object.assign({}, props, { classes: { tooltip: className } }), children));
})(({ theme }) => ({
    fontSize: "1.6rem", //"var(--default-text-font-size)",
    fontFamily: "BrownStd-Regular", //"var(--default-font-family)",
    color: "#fff", //"var(--clr-white)",
    pointerEvents: "auto",
}));
const Button_closeButton = styled(Button)(({ theme }) => ({
    color: "#009fe0", //"var(--clr-secondary)",
    backgroundColor: "#fff", //"var(--clr-white)",
    marginLeft: "auto",
    display: "block",
    fontSize: "1.2rem",
    fontFamily: "BrownStd-Regular", //"var(--default-font-family)",
    "&:hover": {
        color: "#fff", //"var(--clr-white)",
        backgroundColor: "#009fe0", //"var(--clr-secondary)",
    },
}));
const keyframes_rotate_arrow = keyframes({
    "0%": {
        transform: "rotate(90deg)",
    },
    "100%": {
        transform: "rotate(0deg)",
    },
});
const keyframes_invisible = keyframes({
    "0%": {
        color: "white",
    },
    "100%": {
        color: "white",
    },
});
const BreadcrumbPart = observer((props) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const renderMenu = () => {
        if (props.entry.values) {
            return (React.createElement(Menu_menu, { id: "menu_" + props.entry.label, open: menuOpen, onClose: () => setMenuOpen(false), anchorEl: anchorEl }, props.entry.values.map((value) => {
                return (React.createElement(MenuItem, { key: "breadcrumb_" + value.id, selected: value.id == props.entry.selectedValue, onClick: () => {
                        setMenuOpen(false);
                        props.entry.onValueSelected(value.id);
                    } },
                    React.createElement(Typography_menuItem, { variant: "body1", font: props.appModel.theme.fontFamily }, value.label)));
            })));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    const renderIcon = () => {
        return (React.createElement(IconButton_separator, { id: "iconBread", disabled: true, buttoncolor: props.appModel.theme.primaryColor },
            React.createElement(NavigateNextIcon, null)));
    };
    const renderSeparator = () => {
        if (!props.entry.label) {
            return React.createElement(Grid, { item: true });
        }
        else if (props.entry.tooltip) {
            return (React.createElement(Grid, { item: true },
                React.createElement(Tooltip_tooltip, { open: props.entry.tooltip.open, onClose: props.entry.tooltip.onClose, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, title: React.createElement("div", { style: {
                            maxWidth: props.entry.tooltip.maxWidth
                                ? props.entry.tooltip.maxWidth
                                : 300,
                        } },
                        props.entry.tooltip.label,
                        React.createElement(Button_closeButton, { onClick: props.entry.tooltip.onClose }, props.appModel.i18n("tooltip.understood"))), PopperProps: { disablePortal: true }, arrow: true }, renderIcon())));
        }
        else {
            return React.createElement(Grid, { item: true }, renderIcon());
        }
    };
    const onArrowClick = (event) => {
        if (props.entry.values) {
            setAnchorEl(event.currentTarget);
            setMenuOpen(true);
        }
    };
    const renderArrow = props.entry.values ? (React.createElement(Div_clickableLabelWrapper, null,
        React.createElement(ArrowDropDown_chevron, { onClick: onArrowClick, color: props.appModel.theme.primaryColor }))) : (React.createElement(React.Fragment, null));
    const renderLabel = props.entry.onClick ? (React.createElement(Typography_entryLabel_clickableLabelWrapper, { variant: "subtitle1", onClick: props.entry.onClick, color: props.appModel.theme.primaryColor, font: props.appModel.theme.fontFamilyBold }, props.entry.label)) : (React.createElement(Typography_entryLabel, { variant: "subtitle1", color: props.appModel.theme.primaryColor, font: props.appModel.theme.fontFamilyBold }, props.entry.label));
    const renderLabelAndArrow = () => {
        const labelWrapperStyle = props.entry.values
            ? { maxWidth: "calc(100% - 2.4rem)" }
            : { maxWidth: "calc(100% - 1.5rem)" };
        return (React.createElement(Grid_labelWrapper, { item: true, sx: labelWrapperStyle },
            renderLabel,
            renderArrow));
    };
    return (React.createElement(Grid_breadcrumbEntry, { className: "breadcrumbpart", item: true },
        renderSeparator(),
        renderLabelAndArrow(),
        renderMenu()));
});
export default BreadcrumbPart;
